<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <search :search-action="searchData" />
        </b-col>
        <b-col md="auto">
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
        <b-col
          v-if="detailSearch"
          cols="12"
        >
          <filter-data :filter-action="getFilteredData" />
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
        fixed
      >
        <template #cell(company)="data">
          <b-link
            class="text-body"
            :to="$route.path + '/view/' + data.item.id"
          >
            <div>{{ data.item.company }}</div>
            <div class="font-small-3 text-primary">
              {{ data.item.name }}
            </div>
          </b-link>
        </template>
        <template #cell(country)="data">
          <div>{{ data.item.country }}</div>
          <div class="font-small-3 text-info">
            {{ data.item.city }}
          </div>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <list-buttons
              primary-text="Görüntüle"
              :primary-action="$route.path + '/view/' + data.item.id"
              :edit-action="$route.path + '/edit/' + data.item.id"
              :delete-action="removeData"
              :data-id="data.item.id"
            />
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BTable, BPagination, BButton, BCardFooter, BLink,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Search from '@/views/Admin/Suppliers/FilterData/Search.vue'
import FilterData from '@/views/Admin/Suppliers/FilterData/FilterData.vue'

const tableName = 'suppliers'
export default {
  name: 'SuppliersIndex',
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BLink,
    ListButtons,
    Search,
    FilterData,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'company',
          label: 'FİRMA ADI',
        },
        {
          key: 'phone',
          label: 'TELEFON',
          thStyle: { width: '200px' },
        },
        {
          key: 'country',
          label: 'BÖLGE',
          thStyle: { width: '160px' },
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '180px' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.company AS company`,
          `${tableName}.phone AS phone`,
          'countries.title AS country',
          'cities.title AS city',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['suppliers/dataList']
    },
    dataCounts() {
      return this.$store.getters['suppliers/dataCounts']
    },
    saveData() {
      return this.$store.getters['suppliers/dataSaveStatus']
    },
    detailSearch() {
      return this.$store.getters['suppliers/detailSearch']
    },
    filterData() {
      return this.$store.getters['suppliers/filterData']
    },
    searchKeyword() {
      return this.$store.getters['suppliers/search']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.searchKeyword.keyword) {
        this.dataQuery.or_like = {
          'suppliers.company': this.searchKeyword.keyword,
          'suppliers.phone': this.searchKeyword.keyword,
          'suppliers.tax_number': this.searchKeyword.keyword,
        }
        this.getDataList()
      } else {
        this.dataQuery.or_like = {}
        this.getDataList()
      }
    },
    getFilteredData() {
      const where = {}
      const filterData = {
        id_sectors: [],
        id_activities: [],
      }
      if (this.filterData.id_meets) {
        where['suppliers.id_meets'] = this.filterData.id_meets
      }
      if (this.filterData.id_countries) {
        where['suppliers.id_countries'] = this.filterData.id_countries
      }
      if (this.filterData.id_cities) {
        where['suppliers.id_cities'] = this.filterData.id_cities
      }
      if (this.filterData.id_sectors) {
        filterData.id_sectors = this.filterData.id_sectors
      }
      if (this.filterData.id_activities) {
        filterData.id_activities = this.filterData.id_activities
      }
      this.dataQuery.where = where
      this.dataQuery.filterData = filterData
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('suppliers/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('suppliers/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
